import React from "react";
import { useParams } from "react-router-dom";
import ContentSpace from "../client/ContentSpace";

export default function AdminContentSpace() {
  const { id } = useParams();
  return <ContentSpace adminClientId={id} />;
}
